import { create } from "zustand";

/*
 * bflowStore — A/B variant B ke post-call state ka chhota sa ghar.
 *
 * Kyun store: asli phone call ka pata SOCKET ko chalta hai
 * (initNotificationSocket → phone_call_completed), par use dikhana
 * /agent-live screen ko hai. Dono ke beech koi seedha rishta nahi hai.
 *
 * Pehle socket seedha /call-summary pe navigate kar deta tha. Ab requirement
 * badal gayi: call detect hote hi user ko usi screen pe "Call captured" card
 * dikhna chahiye, aur detail tab khule jab wo "Click for details" dabaye.
 * Isliye socket sirf yahan value rakh deta hai aur screen use padh leti hai.
 */
export const useBflowStore = create((set) => ({
    // { callId, agentId, duration_ms, caller_name, from_number, reason, ... }
    capturedCall: null,

    // Asli phone call ABHI chal rahi hai (call_started aaya, call_analyzed nahi).
    // Isi se waiting modal "Call in progress" dikhata hai aur uska timeout ruk
    // jaata hai — warna lambi call ke doran "No call detected" aa jaata tha.
    callInProgress: false,

    // Call shuru hui. capturedCall saaf kar dete hain: agar user dobara call kar
    // raha hai to purani call ka card dikhte rehna galat hai.
    startCall: () => set({ callInProgress: true, capturedCall: null }),

    setCapturedCall: (call) =>
        set({ capturedCall: call || null, callInProgress: false }),

    // Screen chhodte waqt saaf kar do, warna user dobara /agent-live pe aakar
    // purani call ka card dekhta rahega.
    clearCapturedCall: () => set({ capturedCall: null, callInProgress: false }),
}));
